import { route } from "../../../../application/domain/routing/named-route";
import { ServiceAccountCreatePage } from "./service-account-create";
import { ServiceAccountDetailPage } from "./service-account-detail";
import { ServiceAccountsPage } from "./service-accounts";

// https://github.com/graffer-inc/cloud-gov/blob/fadcd0c0a77d438832d4ab00e6efda478c3d9305/backend/src/domain/utilities/identifier/number_id.go#L18
const REG_EXP_STR_FOR_SERVICE_ACCOUNT_ID = "[0-9]{19}";

export const ServiceProviderServiceAccountRoutes = {
  ServiceAccounts: route({
    path: "/service-provider/orgs/:tenantId/service-accounts",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/service-accounts`,
    component: ServiceAccountsPage,
  }),
  ServiceAccountCreate: route({
    path: "/service-provider/orgs/:tenantId/service-accounts/create",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/service-accounts/create`,
    component: ServiceAccountCreatePage,
  }),
  ServiceAccountDetail: route({
    path: `/service-provider/orgs/:tenantId/service-accounts/:serviceAccountId(${REG_EXP_STR_FOR_SERVICE_ACCOUNT_ID})`,
    link: (args: {
      tenantId: string;
      serviceAccountId: string;
      isNewlyCreated?: boolean;
    }) =>
      `/service-provider/orgs/${args.tenantId}/service-accounts/${
        args.serviceAccountId
      }${args.isNewlyCreated ? "?isNewlyCreated=true" : ""}`,
    component: ServiceAccountDetailPage,
  }),
};
